export default __webpack_public_path__ + "static/media/customerService.5edd946b.svg";